import dayjs from 'dayjs'
import React from 'react'

import type { DateStringProps } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

export type TableItemDateProps = {
  date: DateStringProps['date']
  now?: string
}

export const TableItemDate = ({ date, now = new Date().toISOString() }: TableItemDateProps) => {
  const day = dayjs(date)

  const renderYear = () => {
    if (day.isAfter(dayjs(now).subtract(1, 'year'))) return null

    return (
      <>
        <br />
        <TimezonedDateString date={date} format="YYYY" />
      </>
    )
  }

  return (
    <>
      <TimezonedDateString
        date={date}
        format={day.isAfter(dayjs(now).subtract(12, 'hour')) ? 'h:mm A' : 'MMM D'}
        withTimezoneAbbreviation={false}
      />
      {renderYear()}
    </>
  )
}
